import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { PrimaryButton, LightButton, Forbidden } from '../../../components';

import styles from '../Modals.module.css';

export const NotificacionInmunoterapiaModal = ({ acept, msg, reject }) => {

  const { permisos } = useSelector(state => state.auth);

  return (permisos.inmunoterapiaUpdate) ? (
    <div>
      <div className="row">
        <div className="col">
          <div className={styles.modalHeader}>¡Cuidado!</div>
        </div>
      </div>
      <div className="row">
        <div className="col">
            <div className="row">
              <div className="col mt-3 mb-3">
                <p>{ msg } ¿Desea continuar?</p>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6">
                <LightButton
                  block={true}
                  icon="X"
                  marginTop={false}
                  onClick={ reject }
                  text="Cancelar"
                  type="button"
                />
              </div>
              <div className='col-xs-12 col-sm-12 col-md-6'>
                <PrimaryButton
                  block={true}
                  icon="Check"
                  marginTop={false}
                  onClick={ acept }
                  text="Continuar"
                  type="button"
                />
              </div>
            </div>
        </div>
      </div>
    </div>
  ) : <Forbidden />
}

NotificacionInmunoterapiaModal.propTypes = {
  acept: PropTypes.func.isRequired,
  reject: PropTypes.func.isRequired,
}